var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { TextVariants } from "../../index";
import { ParagraphSizeEnum } from "./ParagraphSizeEnum";
import { Text as ThemeText } from "theme-ui";
export const TechnicalParagraph = (_a) => {
    var { variant = ParagraphSizeEnum.small } = _a, props = __rest(_a, ["variant"]);
    let textSize = TextVariants.technicalParagraphSmall;
    if (variant === ParagraphSizeEnum.small) {
        textSize = TextVariants.technicalParagraphSmall;
    }
    if (variant === ParagraphSizeEnum.large) {
        textSize = TextVariants.technicalParagraphLarge;
    }
    return _jsx(ThemeText, Object.assign({ sx: { variant: `text.${textSize}` } }, props));
};
export default TechnicalParagraph;
//# sourceMappingURL=TechnicalParagraph.js.map